import { IntegrationsListTab } from '@routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/-integrationSearch'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import type { IntegrationCategory } from 'features/integrations/components/IntegrationMetadata/integrationMetadata'
import { IntegrationListPage } from 'features/integrations/pages/IntegrationList/IntegrationList'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/integrations/directory')({
  component: Page,
  head: () => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const category = urlSearchParams.has('category') ? urlSearchParams.get('category') : 'All'
    return {
      meta: [
        {
          title: withCompanyName(`Libraries & integrations - Directory - ${category}`),
        },
      ],
    }
  },
})

function Page() {
  const { category } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <IntegrationListPage
      activeTab={IntegrationsListTab.Directory}
      activeCategory={category as IntegrationCategory | undefined}
      setActiveCategory={(c) => navigate({ search: { category: c } })}
    />
  )
}
